import React from 'react';
import Box from '@mui/material/Box';
import { Paper, Typography } from '@mui/material';
import { DirectionsCar } from '@mui/icons-material';
import { useActiveVehicle } from 'containers/pages/CANpark/context/ActiveVehicleProvider';
import { getLatestVehicleInfo } from 'containers/pages/CANpark/utils/getLatestVehicleInfo';

const VehicleRecordCard: React.FC = () => {
	const { tickets } = useActiveVehicle();
	// Most recent meaningful description across the plate's full history, so it
	// persists even when older tickets fall outside the lookup window.
	const vehicleInfo = getLatestVehicleInfo(tickets);
	const vehicleRecordsFound = vehicleInfo !== '';

	return (
		<Paper
			variant="outlined"
			sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				borderRadius: 2,
				p: 1.5,
				width: '100%',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<DirectionsCar />
				<Typography
					textAlign={'left'}
					variant={'caption'}
					fontWeight={300}
				>
					Vehicle Information
				</Typography>
			</Box>
			{vehicleRecordsFound ? (
				<Typography
					color={'primary'}
					variant={'body1'}
					fontWeight={300}
					textAlign={'center'}
					width={'100%'}
				>
					{vehicleInfo}
				</Typography>
			) : (
				<Typography
					textAlign={'center'}
					color={'warning.main'}
					variant={'caption'}
					fontWeight={300}
					width={'100%'}
				>
					No recorded vehicle information found
				</Typography>
			)}
		</Paper>
	);
};

export default VehicleRecordCard;
